"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ErrorMessage = _interopRequireDefault(require("../../shared/components/ErrorMessage/ErrorMessage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SubmitButton = function SubmitButtonComponent(_ref) {
  var inFlight = _ref.inFlight,
      ctaText = _ref.ctaText,
      emailPrograms = _ref.emailPrograms,
      error = _ref.error;

  if (error) {
    return /*#__PURE__*/_react["default"].createElement(_ErrorMessage["default"], {
      message: "Oops \u2013 something isn\u2019t working right now. Contact customer support."
    });
  }

  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: emailPrograms,
    className: "recommended-programs__email-cta"
  }, ctaText, inFlight && /*#__PURE__*/_react["default"].createElement("span", {
    className: "button-loader"
  }));
};

SubmitButton.propTypes = {
  error: _propTypes["default"].bool.isRequired,
  inFlight: _propTypes["default"].bool.isRequired,
  ctaText: _propTypes["default"].string.isRequired,
  emailPrograms: _propTypes["default"].func.isRequired
};
var _default = SubmitButton;
exports["default"] = _default;